import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityCondition } from "../../entity/EntityCondition";

export class DtoConditionsPutReq extends EntityCondition {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_condition_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
